import {createAsyncThunk} from "@reduxjs/toolkit";
import {
    addUserParlay,
    setSelectedParlayId,
    updateParlay
} from "./pickX.slice";
import pickXApi from "./pickX.api";
import {
    canAddPlayerToParlayFromData,
    doesParlayExist,
    selectContestsByIds,
    selectPreSelectedParlayById,
    selectUserParlayById
} from "./pickX.selectors";
import {ParlayType, PayoutModel} from "../../constants/PickXEnums";
import Parlay from "../../entities/Parlay";
import tradefanApi from "../tradefan/tradefan.api";
import GlobalConst from "../../constants/GlobalConst";
import {ErrorCodes} from "../../constants/ErrorCodes";
import {selectGamesByIds, selectPlayerById, selectPlayersByIds} from "../sports/sports.selectors";

// non-async thunks

export const setContestPick = ({ contestId, pick, parlayId, removeIfSame }) => (dispatch, getState) => {

    const parlay = selectUserParlayById(getState(), parlayId);
    if (parlay.isContestPickSelected(contestId, pick) && !removeIfSame)
        return;

    const allContestIds = [...parlay.contestIds, contestId];
    const contests = selectContestsByIds(getState(),allContestIds);
    const players = selectPlayersByIds(getState(),contests.map(c => c.PlayerId));
    const games = selectGamesByIds(getState(),contests.map(c=> c.GameId));

    if (!parlay.canAdd(contestId, contests, players, games)) return;

    parlay.setContestPick(contestId, pick);
    dispatch(updateParlay(parlay.toDto()));

};

export const createYourOwnParlay = ({userParlayId}) => (dispatch, getState)=>{

    const state = getState();
    if (doesParlayExist(state, userParlayId))
        return;

    const parlay = new Parlay({
        Id: userParlayId,
        parlayType: ParlayType.CreateYourOwn,
        PayoutModel: PayoutModel.Exact,
        Wager:  GlobalConst.CUSTOM_PARLAY.WAGER,
        WagerCurrency: GlobalConst.SITE_CURRENCY,
    });
    dispatch(addUserParlay(parlay.toDto()));
    dispatch(setSelectedParlayId(parlay.Id));
};

export const createFromPreSelectedParlay = ({preSelectedParlayId, userParlayId})=> (dispatch, getState) => {
    const state = getState();
    if (doesParlayExist(state, userParlayId))
        return;

    const preSelectedParlay = selectPreSelectedParlayById(state, preSelectedParlayId);
    if (!preSelectedParlay) {
        console.error(`PreSelected Parlay with ID ${preSelectedParlayId} not found`);
        return;
    }
    const parlay = new Parlay({
        preSelectedParlayId,
        parlayType: ParlayType.CreateFromPreSelected,
        Id: userParlayId,
        PayoutModel: preSelectedParlay.PayoutModel,
        Wager: preSelectedParlay.Fee,
        WagerCurrency: preSelectedParlay.FeeCurrency,
    }).setEmptyContestsPicks(preSelectedParlay.ContestIds);

    dispatch(addUserParlay(parlay.toDto()));
    dispatch(setSelectedParlayId(parlay.Id));
}

export const createNewParlayFromLastPlacedParlay = () => (dispatch, getState) => {
    const state = getState();
    const lastPlacedParlay = state.pickX.placingParlayState.lastPlacedParlay;
    if (!lastPlacedParlay) {
        console.error("Last placed parlay not found");
        return;
    }
    if (lastPlacedParlay.parlayType === ParlayType.CreateYourOwn)
        dispatch(createYourOwnParlay({userParlayId: "newCreateYourOwn"}));
    else if (lastPlacedParlay.parlayType === ParlayType.CreateFromPreSelected)
        dispatch(createFromPreSelectedParlay({preSelectedParlayId: lastPlacedParlay.preSelectedParlayId,
                                                     userParlayId: "newFrom_" + lastPlacedParlay.preSelectedParlayId}));
}

//async

export const submitParlayAsync = createAsyncThunk('pickX/submitParlay',async ({parlay}, {dispatch, getState, rejectWithValue}) => {
    try{
        //check if all contests are not started
        const userParlay = new Parlay(parlay);
        const contests = selectContestsByIds(getState() , userParlay.contestIds);
        const games = contests.map(c=>getState().sports.games[c.GameId]);
        const allContestsNotStarted = !games.find(g=>g.GL < 1.0);
        if (!allContestsNotStarted){
            return rejectWithValue({
                code: ErrorCodes.CONTEST_ALREADY_STARTED
            });
        }

        const res = await dispatch(pickXApi.endpoints.submitParlay.initiate({Parlay:userParlay.toDto(), CorrelationId: parlay.Id})).unwrap();
        return res;
    }
    catch (error) {
        console.error(error);
        return rejectWithValue(error.message);
    }
});